import React from 'react';
import PropTypes from 'prop-types';
import { ICONS } from '../../atoms/Icon';

const Icon = ({ icon, alt, imgStyle }) => (
  <img src={ICONS[icon]} alt={alt} className={imgStyle} />
);
Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  alt: PropTypes.string,
  imgStyle: PropTypes.string,
};

Icon.defaultProps = {
  alt: '',
  imgStyle: '',
};

export default Icon;



// WEBPACK FOOTER //
// src/components/molecules/Icon/index.jsx